import { getPasswordPolicy, PasswordPolicy } from '../api/passwordRecovery';
import { useLocation } from 'react-router-dom';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export const getPasswordPolicyDescription = (policy: PasswordPolicy): string => {
  return `От ${policy.min_length} до ${policy.max_length} символов, хотя бы один — не пробел. Можно использовать любые буквы, пробелы и emoji. Emoji могут занимать два символа.`;
};

export const getNewPasswordError = (password: string, policy?: PasswordPolicy): string => {
  if (!password) return 'Введите новый пароль';
  if (!policy) return 'Не удалось загрузить требования к паролю. Попробуйте ещё раз.';
  if (!/[^\p{White_Space}]/u.test(password)) return 'Пароль не может состоять только из пробелов';
  return password.length < policy.min_length || password.length > policy.max_length
    ? `Пароль должен содержать от ${policy.min_length} до ${policy.max_length} символов` : '';
};

export const usePasswordPolicy = (): UseQueryResult<PasswordPolicy, Error> => {
  const location = useLocation();
  return useQuery({
    queryFn: getPasswordPolicy,
    queryKey: ['getPasswordPolicy', location.pathname],
    retry: false,
    staleTime: 300_000
  });
};